import { useState, useEffect, useCallback } from 'react';

export const useDropdown = () => {
    const [dropdownOpenId, setDropdownOpenId] = useState(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const withinActions = event.target.closest(".post-card__actions") || event.target.closest(".post-actions");
            const withinDropdown = event.target.closest(".post-card__dropdown") || event.target.closest(".post-dropdown");

            if (!withinActions && !withinDropdown) {
                setDropdownOpenId(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (dropdownOpenId === null) {
            return undefined;
        }

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setDropdownOpenId(null);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [dropdownOpenId]);

    const toggleDropdown = useCallback((postId) => {
        setDropdownOpenId((currentOpenId) => (currentOpenId === postId ? null : postId));
    }, []);

    return {
        dropdownOpenId,
        setDropdownOpenId,
        toggleDropdown,
    };
}; 
